// Modules
import { useState, useEffect } from "react"
import { toast } from "react-toastify"
import { useParams } from "react-router-dom"

// Services
import PerkService from "~services/PerkService"

// Components
import PageContent from "~components/PageContent"
import PerkDetail from "~components/perks/PerkDetail"

// Interfaces
import { PerkShape } from "~shapes/perk"

const Perk = () => {
  const { id } = useParams<{ id: string }>()

  // Component state
  const [perk, setPerk] = useState<PerkShape>(null!)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  // Component effects
  useEffect(() => {
    if (id) fetchPerk(id!)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  // Method to fetch a perk by ID and save it in the state
  const fetchPerk = (id: string) => {
    PerkService.getPerk(id)
      .then((perk: PerkShape) => {
        setPerk(perk)
      })
      .catch(() => {
        toast.error(`Failed to load the Perk`)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <PageContent>
      <PerkDetail perk={perk} isLoading={isLoading} />
    </PageContent>
  )
}

export default Perk
